import { mapQuarterlyTableDataToTotalData } from 'legacy/lut/components/widgets/public/partner360/helpers/report/mapQuarterlyTableDataToTotalData'

import {
  IQuarterlyMarketTableRow,
  TQuarterlyViewTotalData,
} from 'partner360/models/report/sobAnalyticsReports/iQuarterlyMarketTableRow'

export const getQuarterlyViewTotalData = (
  totalData: IQuarterlyMarketTableRow
): TQuarterlyViewTotalData => ({
  partnersCount: totalData.partnersCount,
  prevYearSobActual: totalData.prevYearSobActual,
  prevYearSobActualNet: totalData.prevYearSobActualNet,
  prevYearSobActualTNet: totalData.prevYearSobActualTNet,
  prevYearSobActualUTNet: totalData.prevYearSobActualUTNet,

  currYearSobPlan: totalData.currYearSobPlan,
  currYearSobPlanNet: totalData.currYearSobPlanNet,
  currYearSobPlanTNet: totalData.currYearSobPlanTNet,
  currYearSobPlanUTNet: totalData.currYearSobPlanUTNet,

  currYearSobActual: totalData.currYearSobActual,
  currYearSobActualNet: totalData.currYearSobActualNet,
  currYearSobActualTNet: totalData.currYearSobActualTNet,
  currYearSobActualUTNet: totalData.currYearSobActualUTNet,

  prevYearYoYPP: totalData.prevYearYoYPP,
  prevYearYoYPPNet: totalData.prevYearYoYPPNet,
  prevYearYoYPPTNet: totalData.prevYearYoYPPTNet,
  prevYearYoYPPUTNet: totalData.prevYearYoYPPUTNet,

  prevYearVsPlan: totalData.prevYearVsPlan,
  prevYearVsPlanNet: totalData.prevYearVsPlanNet,
  prevYearVsPlanTNet: totalData.prevYearVsPlanTNet,
  prevYearVsPlanUTNet: totalData.prevYearVsPlanUTNet,

  currYearPlansRevenue: totalData.currYearPlansRevenue,
  currYearPlansRevenueNet: totalData.currYearPlansRevenueNet,
  currYearPlansRevenueTNet: totalData.currYearPlansRevenueTNet,
  currYearPlansRevenueUTNet: totalData.currYearPlansRevenueUTNet,

  currYearActualsRevenue: totalData.currYearActualsRevenue,
  currYearActualsRevenueNet: totalData.currYearActualsRevenueNet,
  currYearActualsRevenueTNet: totalData.currYearActualsRevenueTNet,
  currYearActualsRevenueUTNet: totalData.currYearActualsRevenueUTNet,

  currYearSalesPerformance: totalData.currYearSalesPerformance,
  currYearSalesPerformanceNet: totalData.currYearSalesPerformanceNet,
  currYearSalesPerformanceTNet: totalData.currYearSalesPerformanceTNet,
  currYearSalesPerformanceUTNet: totalData.currYearSalesPerformanceUTNet,

  currYearYoYGrowth: totalData.currYearYoYGrowth,
  currYearYoYGrowthNet: totalData.currYearYoYGrowthNet,
  currYearYoYGrowthTNet: totalData.currYearYoYGrowthTNet,
  currYearYoYGrowthUTNet: totalData.currYearYoYGrowthUTNet,
})

interface IGetBusinessPerformanceTotalData {
  data: IQuarterlyMarketTableRow[]
}

export const getBusinessPerformanceTotalData = ({ data }: IGetBusinessPerformanceTotalData) => {
  const totalData = mapQuarterlyTableDataToTotalData({
    tableData: data,
  })

  return getQuarterlyViewTotalData(totalData)
}
